import React from 'react'
import { t } from '../../../i18n'
import { useCatalogue } from '../CatalogueProvider'
import { ProductRow } from '../catalogueTypes'
import CatalogueItemForm from './CatalogueItemForm'
import ProductFormSections from './ProductFormSections'
import {
  CatalogueCancelButton,
  CatalogueDeleteButton,
  CatalogueItemTypeIndicator,
  CatalogueItemTypeSwitch,
  ProductInforSyncBadge,
  CatalogueSubmitButton,
  itemTypeActionLabel,
  itemTypeLabel
} from './CatalogueFormControls'
import { emptyProductValues, productFormValues, productValidationSchema, saveProductOutcome } from './productFormValues'

export const NewProductForm = () => {
  const { state, actions, meta } = useCatalogue()

  return (
    <CatalogueItemForm
      title={`${t('modal.new')} `}
      initialValues={emptyProductValues(meta.weightUnit)}
      save={(values) => saveProductOutcome(actions.saveProduct, values, null, state.categoryId)}
      validationSchema={productValidationSchema}
    >
      <CatalogueItemTypeSwitch value="product" />
      <ProductFormSections />
      <CatalogueCancelButton />
      <CatalogueSubmitButton>{itemTypeActionLabel('create', 'product')}</CatalogueSubmitButton>
    </CatalogueItemForm>
  )
}

export const EditProductForm = ({ product }: { product: ProductRow }) => {
  const { state, actions } = useCatalogue()

  return (
    <CatalogueItemForm
      title={`${t('modal.edit')} ${itemTypeLabel('product')}`}
      initialValues={productFormValues(product, state.categoryOptions)}
      save={(values) => saveProductOutcome(actions.saveProduct, values, product.id, state.categoryId)}
      validationSchema={productValidationSchema}
    >
      <CatalogueItemTypeIndicator value="product" />
      <ProductFormSections modifierBadge={<ProductInforSyncBadge product={product} />} />
      <CatalogueDeleteButton item={product}>{itemTypeActionLabel('delete', 'product')}</CatalogueDeleteButton>
      <CatalogueCancelButton />
      <CatalogueSubmitButton>{t('save')}</CatalogueSubmitButton>
    </CatalogueItemForm>
  )
}
